<template>
<div class="row">
    <nav class="navbar col-12 navbar-expand-lg bg-secondary-navbar px-4 w-100">
        <div class="container">
            <a class="navbar-brand" @click="goToHome">
            <div>
                 <img :src="require( `../../assets/${this.logo}`)" alt="main logo" />
            </div>
            </a>
          </div>
    </nav>
</div>
</template>
<script>

const whitelabel = require('../../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            logo: whitelabel.navbarLogo,
            brand: whitelabel.brand,
        }
    },
    methods: {
        goToHome() {
            if (this.$route.name !== 'Home') {
                this.$router.push({ name: 'Home' })
            }
        },
    },
}
</script>
<style scoped>
    a {
        cursor: pointer;
    }
</style>
